module.exports = __webpack_public_path__ + "static/icons-a18d3a3cf61dac948811c3e2202ae6e3.mp4";